/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import { IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
import { clubMembershipUpdateInput } from '../../../dataActions/DataActionExtension.g';
import { IrsmClubMembershipUpdateResponse } from '../../../dataActions/DataServiceEntities.g';

/**
 * GetMembership Input Action
 */
export class MembershipEditInput implements Msdyn365.IActionInput {
    public input: IDataServiceRequest;
    constructor(input: IDataServiceRequest) {
        this.input = input;
    }

    public shouldCacheOutput = () => false;

    public getCacheKey = () => `IEditMembershipInput`;
    public getCacheObjectType = () => 'IEditMembershipInput';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

export interface IMembershipEditMembershipInput extends IrsmClubMembershipUpdateResponse { }

export interface IInputRequirements {
    WineClubId: string;
    CreditCard: number;
    ShipToAddress: number;
    DeliveryPreference: string;
    PickupLocationId: string;
}

export const createEditMembershipInput = (
    args: Msdyn365.ICreateActionContext,
    { WineClubId, CreditCard, DeliveryPreference, ShipToAddress, PickupLocationId }: IInputRequirements,
): MembershipEditInput => {
    return new MembershipEditInput(
        clubMembershipUpdateInput(
            WineClubId,
            CreditCard,
            ShipToAddress,
            DeliveryPreference,
            PickupLocationId
        )
    );
};

export async function getEditMembershipAction(
    input: MembershipEditInput,
    ctx: Msdyn365.IActionContext,
): Promise<IMembershipEditMembershipInput> {
    return input.input.execute(ctx);
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IMembershipEditMembershipInput>>getEditMembershipAction,
    input: createEditMembershipInput,
});
